export const registerDefaultedField = (fieldName, defaultValue) => ({
  type: 'REGISTER_DEFAULTED_FIELD',
  payload: { fieldName, defaultValue },
});

export const clearDefaultedField = (fieldName) => ({
  type: 'CLEAR_DEFAULTED_FIELD',
  payload: { fieldName },
});

export const clearDefaultedFields = () => ({
  type: 'CLEAR_DEFAULTED_FIELDS',
});

export const storePreviousQuestionData = (previousQuestionData) => ({
  type: 'STORE_PREVIOUS_QUESTION_DATA',
  payload: { previousQuestionData },
});

export const clearPreviousQuestionData = () => ({
  type: 'CLEAR_PREVIOUS_QUESTION_DATA',
});
